export default __webpack_public_path__ + "static/media/013-bomb-detonation-1.b767251d.png";